<script>
import { get } from "@/utils/request";
import { defineComponent, reactive, computed, onMounted, watch } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  props: {
    modelValue: [String, Number, Array],
    dicData: Array,
    dicUrl: String,
    keyMap: Object,
    multiple: Boolean,
    tags: Boolean,
    clearable: {
      type: Boolean,
      default: true,
    },
  },

  setup(props, context) {
    const state = reactive({
      data: [],
    });
    const { t } = useI18n();

    const propMap = computed(() => {
      let map = props.keyMap ? { ...props.keyMap } : {};
      if (!map["label"]) {
        map.label = "label";
      }
      if (!map["value"]) {
        map.value = "value";
      }

      return map;
    });

    watch(
      () => props.dicData,
      (curVal) => {
        state.data = curVal || [];
      },
      { deep: true }
    );

    //api
    const getList = async () => {
      try {
        const { data } = await get(props.dicUrl);
        state.data = data;
      } catch (e) {
        console.log(e);
      }
    };
    //events
    const onChange = (val) => {
      if (val === "") {
        val = undefined;
      }

      context.emit("update:modelValue", val);
      context.emit("change", val);
    };

    onMounted(() => {
      if (Array.isArray(props.dicData)) {
        state.data = props.dicData;
      } else {
        props.dicUrl && getList();
      }
    });

    //
    return () => (
      <el-select
        modelValue={props.modelValue}
        placeholder={t("commonTipSelect")}
        onChange={onChange}
        multiple={props.multiple}
        collapse-tags={props.tags}
        collapse-tags-tooltip={props.tags}
        clearable={props.clearable}
      >
        {state.data.map((opt) => {
          return (
            <el-option
              key={opt[propMap.value.value]}
              value={opt[propMap.value.value]}
              label={opt[propMap.value.label]}
            />
          );
        })}
      </el-select>
    );
  },
});
</script>
